import { Injectable } from '@angular/core';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { Subscription } from 'rxjs/Subscription';
import { map } from 'rxjs/operators/map';
import { distinctUntilChanged } from 'rxjs/operators/distinctUntilChanged';

/**
 *  ScreenSizeService
 *
 *  @fileOverview A service for listening to window resize events.
 *
 *  @example
 *  this.screenSizeService.resizeSubscription$.subscribe( x => console.log(x)) // Listen to window resize events;
 *  this.screenSizeService.getWindowSize(); // Get current window size;
 */


@Injectable()
export class ScreenSizeService {
  resizeSubscription$: Subscription;

  constructor() {
    this.resizeSubscription$ = fromEvent(window, 'resize')
    .pipe(
      map(() => this.getWindowSize()),
      distinctUntilChanged()
    );
  }

  getWindowSize() {
    const screenSize = {
      width: window.innerWidth,
      height: window.innerHeight
    };
    return screenSize;
  }
}
